import { render, staticRenderFns } from "./AddWarrantySeal.vue?vue&type=template&id=cae04774&"
import script from "./AddWarrantySeal.vue?vue&type=script&lang=ts&"
export * from "./AddWarrantySeal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports